import { render, staticRenderFns } from "./promo-section.vue?vue&type=template&id=dc6e0ed0&scoped=true"
import script from "./promo-section.vue?vue&type=script&lang=js"
export * from "./promo-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6e0ed0",
  null
  
)

export default component.exports